import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-collabrator',
  templateUrl: './collabrator.component.html',
  styleUrls: ['./collabrator.component.scss']
})
export class CollabratorComponent {

  public loading:boolean = true;
  public DataListing:any=[];
  public totalCount: number = 0;
  public p :any = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';
  public confirmStatus: boolean = false;
  public Ids:any=''; 
  public sortType:any='desc';

  
  constructor(public router: Router, public service: GlobalService) { 
    if(localStorage.getItem('gra_pogeno')) {
      this.p=localStorage.getItem('gra_pogeno');
      localStorage.removeItem('gra_pogeno');
    }
    this.getDetail(this.p);
  }

  ngOnInit(): void {
  }

  getDetail(page:any){
    var detail={   
      "name": this.searchKey,
      "search_by_role":this.searchKey1,
      "page_id": page,
      sortBy:'createdAt',
      sortOrder:this.sortType

    }; 
    this.service.PostApis(detail,'/collaborator').subscribe(((response:any)=>{
      if(response.success==1){
        this.DataListing = response.data.record;
        this.totalCount = response.data.total;
        this.loading=false;
      } else {
        this.DataListing = [];
        this.totalCount = response.data.total;
        this.loading=false;
      }
    }))  
  }

  requestDelete(){ 
    this.service.DeleteApi('/collaborator-request-delete?request_id='+this.Ids).subscribe(((response:any)=>{
      if(response.success==1){
        this.getDetail(this.p);
        this.loading=false;
      } else {
       this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }))
  }


  redirect(item:any,type:any){
    this.Ids =item._id;
    localStorage.setItem('gra_pogeno',this.p);
    localStorage.setItem('gra_EditData',JSON.stringify(item));
      if(type ==1){
        this.router.navigate(['/program-detail']);
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then((result:any) => {
          let statusType: number = 0;
          if (result.isConfirmed) {
           this.requestDelete();
          }
        });
      }
    }

    reset(){
      this.p=1;
      this.searchKey='';
      this.searchKey1='';
      this.getDetail(this.p);
    }
}
